var map = {
	"./Bitmap.png": 806713,
	"./activity-icon.png": 711309,
	"./activity/newbie-task-gift.svg": 962851,
	"./activity/sign-in-checked.svg": 412257,
	"./activity/task-entry-icon.svg": 592814,
	"./activity/task-guide-arrow.svg": 253556,
	"./activity/task-radio-done.svg": 645126,
	"./activity/task-radio-todo.svg": 231790,
	"./activity/task-rule-info.svg": 591443,
	"./activity/task-tip-arrow.svg": 797563,
	"./add-icon.svg": 329207,
	"./addMeet.png": 375986,
	"./addQuestion.png": 259539,
	"./ai-avatar/agreement-bg.png": 97527,
	"./ai-avatar/ai-avatar-main-bg.png": 882773,
	"./ai-avatar/main-modal-title-en.png": 63797,
	"./ai-avatar/main-modal-title.png": 8405,
	"./ai-avatar/nav-logo-hover.png": 999603,
	"./ai-avatar/nav-logo.png": 981054,
	"./ai-chat-block-parse-error.png": 847456,
	"./ai-chat-icon.png": 825657,
	"./ai-chat/add.png": 834255,
	"./ai-chat/aiChatHome.png": 322493,
	"./ai-chat/chat-bg.png": 299140,
	"./ai-chat/chat-loading.png": 444441,
	"./ai-chat/check.png": 18478,
	"./ai-chat/claw-tip.png": 330013,
	"./ai-chat/close.png": 918634,
	"./ai-chat/cloud_logo.png": 532047,
	"./ai-chat/company_overview.png": 686921,
	"./ai-chat/company_overview_highlight.png": 832832,
	"./ai-chat/csv.png": 92566,
	"./ai-chat/data-source-announcement.png": 173462,
	"./ai-chat/data-source-basic.png": 54273,
	"./ai-chat/data-source-financial.png": 646302,
	"./ai-chat/data-source-fund.png": 16990,
	"./ai-chat/data-source-macro.png": 867271,
	"./ai-chat/data-source-market.png": 940075,
	"./ai-chat/data-source-news.png": 393326,
	"./ai-chat/data-source-research.png": 488188,
	"./ai-chat/data_cube.png": 679282,
	"./ai-chat/default_avatar.png": 448813,
	"./ai-chat/doc.png": 225868,
	"./ai-chat/event_review.png": 414935,
	"./ai-chat/event_review_highlight.png": 365978,
	"./ai-chat/file.png": 286274,
	"./ai-chat/generate_company_brief.png": 383868,
	"./ai-chat/generate_company_report_en.png": 428812,
	"./ai-chat/generate_company_report_zh.png": 37119,
	"./ai-chat/generate_industry_depth_en.png": 688754,
	"./ai-chat/generate_industry_depth_zh.png": 840597,
	"./ai-chat/generate_macro_strategy_en.png": 830426,
	"./ai-chat/generate_macro_strategy_zh.png": 663309,
	"./ai-chat/global-search.png": 265932,
	"./ai-chat/greet.png": 415309,
	"./ai-chat/hot-domestic-report.png": 647007,
	"./ai-chat/hot-foreign-report.png": 438601,
	"./ai-chat/hot-summary.png": 333804,
	"./ai-chat/html-preview/zoom-in.png": 148498,
	"./ai-chat/html-preview/zoom-in.svg": 747628,
	"./ai-chat/html-preview/zoom-out.png": 447203,
	"./ai-chat/html-preview/zoom-out.svg": 598067,
	"./ai-chat/html.png": 32171,
	"./ai-chat/icon-research-analyzing.png": 313883,
	"./ai-chat/icon-research-customize.png": 403919,
	"./ai-chat/icon-research-industry.png": 46618,
	"./ai-chat/icon-research-stock.png": 795768,
	"./ai-chat/img.png": 199983,
	"./ai-chat/indicators_load_bg.png": 725541,
	"./ai-chat/industry_overview.png": 404090,
	"./ai-chat/industry_overview_highlight.png": 874151,
	"./ai-chat/industry_popular_science.png": 45567,
	"./ai-chat/jinbao.png": 167547,
	"./ai-chat/link.png": 668168,
	"./ai-chat/markdown.png": 621367,
	"./ai-chat/mcp-auth-success.png": 251165,
	"./ai-chat/mcp-connector-icon-eastmoney.png": 909986,
	"./ai-chat/mcp-connector-icon-ifind.png": 400031,
	"./ai-chat/mcp-connector-icon-ima.png": 761420,
	"./ai-chat/mcp-connector-icon-investoday.png": 992715,
	"./ai-chat/mcp-connector-icon-qieman.png": 265950,
	"./ai-chat/mcp-connector-icon-tdx.png": 891383,
	"./ai-chat/mcp-connector-icon-tushare.png": 146593,
	"./ai-chat/mcp-connector-icon-wind.png": 870685,
	"./ai-chat/mcp-service-default-icon.png": 904772,
	"./ai-chat/mcp_bg.png": 376030,
	"./ai-chat/menu.png": 200181,
	"./ai-chat/new-tip.png": 824080,
	"./ai-chat/no_check.png": 779440,
	"./ai-chat/note.png": 493532,
	"./ai-chat/other_file.png": 951827,
	"./ai-chat/pdf.png": 151180,
	"./ai-chat/performance_review.png": 881097,
	"./ai-chat/performance_review_highlight.png": 246272,
	"./ai-chat/ppt.png": 935506,
	"./ai-chat/question_tip.png": 115294,
	"./ai-chat/recommend.svg": 659032,
	"./ai-chat/report_logo.png": 285826,
	"./ai-chat/research-action-menu/cloud-import.svg": 293020,
	"./ai-chat/research-action-menu/folder.svg": 270123,
	"./ai-chat/research-action-menu/local-import.svg": 9294,
	"./ai-chat/research-file-type/excel.svg": 276633,
	"./ai-chat/research-file-type/file.svg": 553202,
	"./ai-chat/research-file-type/folder-custom.svg": 683000,
	"./ai-chat/research-file-type/folder-default.svg": 485532,
	"./ai-chat/research-file-type/folder-industry.svg": 721923,
	"./ai-chat/research-file-type/folder-stock.svg": 467813,
	"./ai-chat/research-file-type/html.svg": 890655,
	"./ai-chat/research-file-type/image.svg": 198679,
	"./ai-chat/research-file-type/md.svg": 743715,
	"./ai-chat/research-file-type/pdf.svg": 260906,
	"./ai-chat/research-file-type/ppt.svg": 675132,
	"./ai-chat/research-file-type/word.svg": 983504,
	"./ai-chat/research-session.png": 647404,
	"./ai-chat/research.png": 668175,
	"./ai-chat/research_review.png": 703444,
	"./ai-chat/research_review_highlight.png": 374837,
	"./ai-chat/roadshow.png": 66425,
	"./ai-chat/sandbox-sleep.png": 797273,
	"./ai-chat/session-compress-left.svg": 359215,
	"./ai-chat/session-compress-right.svg": 474890,
	"./ai-chat/share-bg.png": 366555,
	"./ai-chat/share-header-bg.png": 483509,
	"./ai-chat/sheet_paper_bg.png": 9436,
	"./ai-chat/sheet_paper_title_left.svg": 36061,
	"./ai-chat/sheet_paper_title_right.svg": 762592,
	"./ai-chat/skill-shortcuts/icon-bianji.png": 864971,
	"./ai-chat/skill-shortcuts/icon-create-skill.png": 518466,
	"./ai-chat/skill-shortcuts/icon-diaoyan.png": 326307,
	"./ai-chat/skill-shortcuts/icon-gongzhonghao.png": 532957,
	"./ai-chat/skill-shortcuts/icon-hangye.png": 459620,
	"./ai-chat/skill-shortcuts/icon-quanshang.png": 892566,
	"./ai-chat/skill-shortcuts/icon-shengtu.png": 282390,
	"./ai-chat/skill-shortcuts/icon-tonghuashun.png": 417884,
	"./ai-chat/skill-shortcuts/icon-twitter.png": 425321,
	"./ai-chat/skill-shortcuts/icon-youdao.png": 891965,
	"./ai-chat/summary.png": 991178,
	"./ai-chat/summary_file.png": 508245,
	"./ai-chat/summary_logo.png": 148162,
	"./ai-chat/transfer.png": 74385,
	"./ai-chat/translation.png": 489719,
	"./ai-chat/txt.png": 894542,
	"./ai-chat/viewpoint_comparison.png": 168405,
	"./ai-chat/viewpoint_comparison_highlight.png": 17348,
	"./ai-chat/web_logo.png": 214820,
	"./ai-chat/wechat-share-bg.png": 202370,
	"./ai-chat/weichat_logo.png": 971007,
	"./ai-chat/xlsx.png": 989917,
	"./ai-global-search.png": 549531,
	"./ai-look-bg.png": 744706,
	"./ai-mask.png": 548113,
	"./ai-note-active.png": 773102,
	"./ai-note-error.png": 331432,
	"./ai-note.png": 836197,
	"./ai-note/ai-note-hover.png": 799318,
	"./ai-note/ai-note-tips-bg.png": 98038,
	"./ai-note/ai-note.png": 643243,
	"./ai-note/ai-notice-delete.png": 874367,
	"./ai-note/ai-notice.png": 143275,
	"./ai-note/auto-signup-tip.png": 24450,
	"./ai-note/file-down.gif": 947208,
	"./ai-png.png": 389000,
	"./ai-red.png": 867212,
	"./ai-research-brain-tag.png": 7742,
	"./ai-research.png": 478866,
	"./ai-search-gif.gif": 344635,
	"./ai-search-logo.png": 40385,
	"./ai-search-logo1.png": 675340,
	"./ai-tools.svg": 884626,
	"./ai-tools/ai-twins.png": 824493,
	"./ai-tools/audio-record.png": 67541,
	"./ai-tools/database-detail.png": 990758,
	"./ai-tools/mcp-detail.png": 404139,
	"./ai-tools/meeting-record.png": 786482,
	"./ai-tools/record-meeting-background.png": 358821,
	"./ai-tools/record-meeting-contact.png": 356813,
	"./ai-tools/transcription.png": 275937,
	"./ai-tools/translate.png": 699363,
	"./ai.png": 523662,
	"./aiBtn.png": 971252,
	"./analyst-all.png": 568166,
	"./analyst-card-bg-hover.png": 60992,
	"./analyst-card-bg.png": 933673,
	"./answer-en.png": 813844,
	"./answer.png": 832582,
	"./answer.svg": 831332,
	"./audio-pause.png": 71313,
	"./audio-recorder-hover.png": 102556,
	"./audio-recorder.png": 440293,
	"./authority.png": 360401,
	"./auto-report-header.png": 439470,
	"./auto-report-notice-frame.png": 356149,
	"./auto-report-notice.png": 715513,
	"./beComeing_icon.png": 784491,
	"./bg-ent-live-right.png": 588555,
	"./bg_schedule_main.png": 412425,
	"./book.png": 790563,
	"./book_meeting.png": 261333,
	"./brm-download-qrcode.png": 852771,
	"./brm-logo-en.svg": 168507,
	"./brmAi.png": 458617,
	"./brmAiHover.png": 752963,
	"./card-bg-member.png": 188569,
	"./center-img.png": 113597,
	"./chat-loading.gif": 633310,
	"./checkedIcon.png": 825554,
	"./claw.png": 754837,
	"./clear-upload.svg": 989541,
	"./close-btn.png": 868537,
	"./close.png": 923474,
	"./cloud/20260716-172548.png": 799070,
	"./cloud/active-document.png": 747368,
	"./cloud/active-folder.png": 694631,
	"./cloud/active-knowledge.png": 764007,
	"./cloud/active-recent.png": 396234,
	"./cloud/active-summary.png": 728371,
	"./cloud/audio-player-bg.png": 234936,
	"./cloud/audio-player-icon.png": 705354,
	"./cloud/black-down.png": 45076,
	"./cloud/blue-down.png": 647753,
	"./cloud/combined.png": 875,
	"./cloud/docx-3.png": 703376,
	"./cloud/docx.png": 475036,
	"./cloud/down.png": 93510,
	"./cloud/folder-bg.png": 338456,
	"./cloud/folder.png": 70054,
	"./cloud/icon-knowlegde-color.svg": 674892,
	"./cloud/icon-my-doc-color.svg": 596185,
	"./cloud/icon-my-doc.svg": 71499,
	"./cloud/icon-my-knowlegde.svg": 780959,
	"./cloud/icon-my-summary-color.svg": 324123,
	"./cloud/icon-search-history.png": 387959,
	"./cloud/icon-shortcut.png": 692690,
	"./cloud/knowledge.png": 850000,
	"./cloud/more.png": 215321,
	"./cloud/my-document.png": 963708,
	"./cloud/my-summary.png": 23135,
	"./cloud/own-docx-3.png": 355141,
	"./cloud/own-docx.png": 614485,
	"./cloud/own-folder-bg.png": 750623,
	"./cloud/private.png": 382601,
	"./cloud/recent.png": 122419,
	"./cloud/section-empty-ai-avatar.png": 88150,
	"./cloud/section-empty-ai-note.png": 784709,
	"./cloud/section-empty-meeting.png": 39397,
	"./cloud/section-empty-transcribe.png": 306465,
	"./cloud/section-empty-wechat-chat.png": 90379,
	"./cloud/section-empty-wechat-qr-deco.png": 886108,
	"./cloud/share.png": 357093,
	"./cloud/tag-empty.png": 20188,
	"./cloud/wechat-assistant-card-bg.png": 562918,
	"./code_bg.png": 131085,
	"./com-code-login.png": 106607,
	"./com-header-bg.png": 868991,
	"./comein-vip.svg": 532217,
	"./comment-icon.png": 219031,
	"./commitment_demo.png": 308145,
	"./company.png": 330583,
	"./company_logo_en.svg": 656967,
	"./compare-echarts-dataZoom-handleIcon.svg": 498302,
	"./consult_hg.png": 13292,
	"./content-vip.svg": 473559,
	"./cron-job-empty-icon.svg": 141590,
	"./custom-web-pay/org-exclusive/org-exclusive-permissions.svg": 268624,
	"./custom-web-pay/org-exclusive/org-exclusive-platform.svg": 813389,
	"./custom-web-pay/org-exclusive/org-exclusive-seats.svg": 455766,
	"./custom-web-pay/org-exclusive/org-exclusive-security.svg": 784566,
	"./custom-web-pay/org-exclusive/org-exclusive-support.svg": 877249,
	"./custom-web-pay/org-exclusive/org-exclusive-unlimited.svg": 664409,
	"./custom-web-pay/retention/card-texture.png": 627695,
	"./custom-web-pay/retention/close-new.svg": 554404,
	"./custom-web-pay/retention/dialog-bg.png": 649647,
	"./custom-web-pay/retention/row-ai.svg": 633504,
	"./custom-web-pay/retention/row-lobster.svg": 981389,
	"./custom-web-pay/retention/row-research.svg": 23581,
	"./custom-web-pay/retention/tip-icon.svg": 277120,
	"./customerService/bg-wechat-service.png": 902328,
	"./customerService/icon-customer-service.png": 355144,
	"./customerService/icon-wechat.png": 743240,
	"./customerService/jinmen-assistant-qrcode.png": 639963,
	"./customerService/meeting-robot-qrcode.png": 759783,
	"./customerService/status-disabled-bg.svg": 490247,
	"./daily/bright-bg.png": 216992,
	"./daily/daily-logo-morning-en.svg": 911502,
	"./daily/daily-logo-morning.svg": 414526,
	"./daily/daily-logo-night-en.svg": 115748,
	"./daily/daily-logo-night.svg": 394668,
	"./daily/daily-logo-noon-en.svg": 476636,
	"./daily/daily-logo-noon.svg": 82068,
	"./daily/hotspot-active.svg": 781820,
	"./daily/hotspot-deactive.svg": 375749,
	"./daily/hotspot-news-logo.svg": 563725,
	"./daily/hotspot.png": 436525,
	"./daily/industry-logo-1.svg": 52920,
	"./daily/industry-logo-2.svg": 391755,
	"./daily/morning-logo.svg": 744696,
	"./daily/night-logo.svg": 105850,
	"./daily/noon-logo.svg": 798270,
	"./daily/table-ico.svg": 256648,
	"./danger.png": 982385,
	"./default-bg.png": 955125,
	"./default-photo.png": 883406,
	"./defaultPoster.jpeg": 155615,
	"./defaultPoster1.jpg": 118717,
	"./defaultPoster2.jpg": 99762,
	"./defaultPoster3.jpg": 176143,
	"./defaultPoster4.jpg": 833412,
	"./defaultPoster5.jpg": 27809,
	"./delete-hover.svg": 881454,
	"./delete.png": 308749,
	"./delete.svg": 965863,
	"./detail_header_bg.png": 807245,
	"./diamond-vip.png": 827504,
	"./disable_select.png": 911367,
	"./doc.png": 624708,
	"./doc_translate.png": 297679,
	"./document.png": 287351,
	"./document_pdf.png": 448160,
	"./document_space_notes.png": 979454,
	"./dot.png": 379019,
	"./drag_empty.png": 89884,
	"./electron/logo.png": 760330,
	"./electron/updater.gif": 564931,
	"./electron/updater.png": 144292,
	"./employee-icon.png": 48556,
	"./empty-trend.png": 607775,
	"./error.png": 576080,
	"./event-signal/icon.svg": 805593,
	"./exclamationPoint.png": 173819,
	"./file-bg.png": 564548,
	"./filter-bg.png": 325848,
	"./filter.png": 504358,
	"./fire.png": 20336,
	"./folder.png": 743116,
	"./follow-bg.png": 986091,
	"./font-size-icon-blue.png": 163854,
	"./font-size-icon.png": 744711,
	"./font-size-select-blue.png": 465907,
	"./font-size-select.png": 655920,
	"./foreign-report-bg.png": 608515,
	"./fundation-bg.png": 444096,
	"./global-search-input.png": 593647,
	"./global-search/global-filter.svg": 429501,
	"./globalGuide/comment-guide.png": 575112,
	"./globalGuide/hot-guide.png": 102010,
	"./globalGuide/industry-chain-guide.png": 939851,
	"./globalGuide/linear-bg.png": 511685,
	"./globalGuide/menu-refactor-en.png": 845282,
	"./globalGuide/menu-refactor.png": 766212,
	"./globalGuide/new-filter.png": 758223,
	"./globalGuide/news-guide.png": 896300,
	"./globalGuide/question-guide.png": 744553,
	"./globalGuide/report-guide.png": 374243,
	"./globalGuide/research-brain-guide.png": 354533,
	"./globalGuide/signal-guide-review.png": 570120,
	"./globalGuide/signal-guide.png": 320925,
	"./globalGuide/summary-filter-guide.png": 124714,
	"./globalGuide/summary-guide.png": 889515,
	"./guide/AI-note.png": 287756,
	"./guide/menu-1.png": 749064,
	"./guide/menu-2.png": 85923,
	"./guide/menu-3.png": 864346,
	"./guide/note-en.png": 617139,
	"./guide/note.png": 61643,
	"./head.png": 564786,
	"./header-bg.png": 733427,
	"./header/more-tool-official-account.svg": 548262,
	"./header/more-tool-wechat-group.svg": 108531,
	"./header/more-tool-wechat-transfer.svg": 18183,
	"./heat-arrow.svg": 141928,
	"./heat.svg": 802316,
	"./hot-one.png": 935656,
	"./hot-question.png": 610878,
	"./hot-stock.png": 755430,
	"./hot-three.png": 307960,
	"./hot-title.png": 102698,
	"./hot-two.png": 23066,
	"./hot.png": 36807,
	"./icon_loading.gif": 172509,
	"./icon_loading.png": 177342,
	"./import-bg.png": 338719,
	"./import-example.png": 205386,
	"./industry.png": 345198,
	"./info-default-bg.png": 151618,
	"./info-hasVip-bg.png": 445516,
	"./is-live.png": 441205,
	"./is-meeting.png": 653432,
	"./is-other.png": 286221,
	"./is-research.png": 255700,
	"./is-vip.png": 83082,
	"./jm-logo-3x.png": 691879,
	"./jm-play.svg": 229224,
	"./join.png": 324208,
	"./join_meeting.png": 722030,
	"./joined.png": 6923,
	"./label-member.png": 307333,
	"./limit-replay.png": 266575,
	"./link.png": 312928,
	"./live.gif": 384485,
	"./loading-blue.png": 95361,
	"./loading-error.png": 724427,
	"./main-bg.png": 262899,
	"./market-trend-title-bg.png": 185879,
	"./market/calendar-icon/my-schedule.svg": 297422,
	"./market/calendar-icon/performance-communication.svg": 163927,
	"./market/calendar-icon/performance-disclosure.svg": 553070,
	"./market/fast-module-icon/question.svg": 458265,
	"./market/fast-module-icon/report.svg": 344667,
	"./market/fast-module-icon/roadshow.svg": 940820,
	"./market/fast-module-icon/summary.svg": 601555,
	"./market/graph-bg.png": 604305,
	"./market/research-shortcut-icon/comment.png": 189167,
	"./market/research-shortcut-icon/question.png": 631558,
	"./market/research-shortcut-icon/report.png": 145620,
	"./market/research-shortcut-icon/summary.png": 667052,
	"./market/stock/candlestick-announce.svg": 419603,
	"./market/stock/candlestick-comment.svg": 60645,
	"./market/stock/candlestick-foreign-report.svg": 39721,
	"./market/stock/candlestick-performance.svg": 708556,
	"./market/stock/candlestick-report.svg": 347184,
	"./market/stock/candlestick-research.svg": 236517,
	"./market/stock/candlestick-roadshow.svg": 259851,
	"./market/stock/research-guide.png": 288004,
	"./market/stock/stock-header-bg.png": 667158,
	"./mcp-oauth/access-illustration.png": 418776,
	"./mcp-oauth/brand-arrow.svg": 194086,
	"./mcp-oauth/capability-icon/analyst-comment.svg": 647914,
	"./mcp-oauth/capability-icon/comein-mcp.svg": 264338,
	"./mcp-oauth/capability-icon/daily-briefing.svg": 369704,
	"./mcp-oauth/capability-icon/meeting-activity.svg": 499487,
	"./mcp-oauth/capability-icon/meeting-minutes.svg": 139683,
	"./mcp-oauth/capability-icon/research-report.svg": 16242,
	"./mcp-oauth/capability-icon/research-skill.svg": 880147,
	"./mcp-oauth/capability-icon/watchlist.svg": 722309,
	"./mcp-oauth/comein-logo.png": 520718,
	"./mcp-oauth/default-client-logo.png": 200118,
	"./mcp-oauth/logo-mark.svg": 872496,
	"./mcp-oauth/logo-text-cn.svg": 548064,
	"./mcp-oauth/logo-text-comein.svg": 668898,
	"./mcp-oauth/page-bg.webp": 753639,
	"./mcp-oauth/qr-corner.svg": 667248,
	"./mcp-oauth/qr-icon.svg": 767504,
	"./mcp-oauth/workbuddy-logo.png": 413470,
	"./mcp-setting-select.svg": 725066,
	"./mcp-setting-unselect.svg": 946871,
	"./meeting-hover.png": 102076,
	"./meeting-popover-bg.png": 460081,
	"./meeting.png": 200325,
	"./member-zone-v2/account-decoration-org.png": 238002,
	"./member-zone-v2/account-decoration.png": 51083,
	"./member-zone-v2/account-ribbon.png": 58261,
	"./member-zone-v2/account-shine-org.png": 547493,
	"./member-zone-v2/account-shine.png": 373080,
	"./member-zone-v2/avatar.png": 662656,
	"./member-zone-v2/brand-mark.svg": 710304,
	"./member-zone-v2/check-gold-outline.svg": 598089,
	"./member-zone-v2/check-gold.svg": 480200,
	"./member-zone-v2/check-purple-outline.svg": 268049,
	"./member-zone-v2/check-purple.svg": 332672,
	"./member-zone-v2/coin.png": 852148,
	"./member-zone-v2/collapse-arrow.svg": 661058,
	"./member-zone-v2/divider.svg": 757206,
	"./member-zone-v2/faq-arrow.svg": 329585,
	"./member-zone-v2/feature-ai.svg": 860982,
	"./member-zone-v2/feature-content.svg": 418323,
	"./member-zone-v2/feature-data.svg": 273332,
	"./member-zone-v2/feature-enterprise.svg": 819289,
	"./member-zone-v2/feature-icon.svg": 793623,
	"./member-zone-v2/feature-research.svg": 391131,
	"./member-zone-v2/feature-task.svg": 854771,
	"./member-zone-v2/mask.svg": 625927,
	"./member-zone-v2/member-advantage-bullet-line-org.svg": 945784,
	"./member-zone-v2/member-advantage-bullet-org.svg": 309543,
	"./member-zone-v2/member-advantage-bullet.svg": 298978,
	"./member-zone-v2/member-advantage-divider.svg": 169421,
	"./member-zone-v2/member-badge-org.png": 689618,
	"./member-zone-v2/member-badge.png": 303915,
	"./member-zone-v2/member-feature-active-decoration-left.svg": 485944,
	"./member-zone-v2/member-feature-active-decoration-right.svg": 940039,
	"./member-zone-v2/member-feature-bullet-line.svg": 505908,
	"./member-zone-v2/member-feature-bullet-org.svg": 645900,
	"./member-zone-v2/member-feature-bullet.svg": 723861,
	"./member-zone-v2/member-feature-divider-org.svg": 301181,
	"./member-zone-v2/member-feature-divider.svg": 947852,
	"./member-zone-v2/member-feature-mode-arrow-org.svg": 917581,
	"./member-zone-v2/member-feature-mode-arrow.svg": 942780,
	"./member-zone-v2/member-org-check.svg": 696807,
	"./member-zone-v2/member-org-divider.svg": 3504,
	"./member-zone-v2/member-org-enterprise-check.svg": 253467,
	"./member-zone-v2/member-org-icon.svg": 219814,
	"./member-zone-v2/page-bg-org.png": 985545,
	"./member-zone-v2/page-bg.png": 76708,
	"./member-zone-v2/pro-icon.png": 912990,
	"./member-zone-v2/sparkle-org.png": 982312,
	"./member-zone-v2/sparkle.png": 199357,
	"./member-zone/Rectangle.png": 644933,
	"./member-zone/active-icon.svg": 215318,
	"./member-zone/arrow-blue.png": 321788,
	"./member-zone/arrow.png": 405485,
	"./member-zone/banner.png": 740546,
	"./member-zone/bar-bg.png": 112157,
	"./member-zone/benefits/arrow-black.svg": 523514,
	"./member-zone/benefits/benefit-icon-1.svg": 642510,
	"./member-zone/benefits/benefit-icon-2.svg": 974509,
	"./member-zone/benefits/benefit-icon-3.svg": 291916,
	"./member-zone/benefits/benefit-icon-4.png": 531503,
	"./member-zone/benefits/group-ai.svg": 931045,
	"./member-zone/benefits/group-content.svg": 487110,
	"./member-zone/benefits/group-data.svg": 357831,
	"./member-zone/benefits/group-enterprise.svg": 184070,
	"./member-zone/benefits/group-meeting.svg": 974462,
	"./member-zone/benefits/group-tools.svg": 832900,
	"./member-zone/benefits/icon-check-alt.svg": 771551,
	"./member-zone/benefits/icon-check-fill.svg": 269425,
	"./member-zone/benefits/icon-check-member.svg": 831016,
	"./member-zone/benefits/icon-check-outline.svg": 377040,
	"./member-zone/benefits/icon-cross.svg": 377625,
	"./member-zone/benefits/icon_gouxuan.svg": 386996,
	"./member-zone/benefits/legend-arrow.svg": 219634,
	"./member-zone/benefits/legend-coin.png": 736570,
	"./member-zone/benefits/org-group-ai.svg": 824926,
	"./member-zone/benefits/org-group-content.svg": 761483,
	"./member-zone/benefits/org-group-data.svg": 961580,
	"./member-zone/benefits/org-group-enterprise.svg": 84241,
	"./member-zone/benefits/org-group-meeting.svg": 186727,
	"./member-zone/benefits/org-group-tools.svg": 323269,
	"./member-zone/benefits/org-icon-check-alt.svg": 218244,
	"./member-zone/benefits/org-icon-check-fill.svg": 217888,
	"./member-zone/benefits/org-icon-check-member.svg": 189353,
	"./member-zone/benefits/org-icon-check-outline.svg": 915759,
	"./member-zone/benefits/org-icon-cross.svg": 305966,
	"./member-zone/benefits/org-instruction-arrow.svg": 416986,
	"./member-zone/benefits/org-instruction-check.svg": 485597,
	"./member-zone/benefits/org-instruction-divider.svg": 236042,
	"./member-zone/benefits/org-instruction-phone.svg": 566581,
	"./member-zone/benefits/org-legend-arrow.svg": 996865,
	"./member-zone/benefits/vector.svg": 454120,
	"./member-zone/bg.png": 6925,
	"./member-zone/billing.svg": 394471,
	"./member-zone/bling1.png": 698867,
	"./member-zone/bling2.png": 524376,
	"./member-zone/border1.png": 925609,
	"./member-zone/border2.png": 377426,
	"./member-zone/btn-bg-blue.png": 804911,
	"./member-zone/btn-bg.png": 520068,
	"./member-zone/close.png": 428390,
	"./member-zone/en-zone-icon-hover.png": 451779,
	"./member-zone/en-zone-icon.png": 824846,
	"./member-zone/icon-right.png": 824678,
	"./member-zone/left.png": 965199,
	"./member-zone/light-blue.png": 904181,
	"./member-zone/light.png": 596930,
	"./member-zone/member-bg.png": 728344,
	"./member-zone/member-font-blue.png": 208361,
	"./member-zone/member-font.png": 945358,
	"./member-zone/membercard-bg.png": 136366,
	"./member-zone/nbi-detail-mcp.svg": 653132,
	"./member-zone/nbi-detail-token.svg": 264439,
	"./member-zone/nbi-gif.gif": 78297,
	"./member-zone/nbi-recharge-arrow.png": 974905,
	"./member-zone/nbi-service-specialist-qr.png": 9347,
	"./member-zone/nbi-service-specialist-qrcode.png": 753324,
	"./member-zone/nbi-service-wechat.svg": 266948,
	"./member-zone/nbi-success.svg": 921021,
	"./member-zone/nbi-tips.png": 722228,
	"./member-zone/nbi-use.svg": 56669,
	"./member-zone/pay-icon-right-blue.png": 980864,
	"./member-zone/pay-icon-right.png": 75401,
	"./member-zone/period.svg": 15713,
	"./member-zone/phone.svg": 117470,
	"./member-zone/play-btn.png": 188469,
	"./member-zone/play-icon.svg": 415214,
	"./member-zone/playback.svg": 653269,
	"./member-zone/playing.png": 457584,
	"./member-zone/right.png": 509248,
	"./member-zone/settlement.svg": 158447,
	"./member-zone/tabs/icons/tab-icon-org-purple.svg": 861219,
	"./member-zone/tabs/icons/tab-icon-pro-gold-active.png": 60369,
	"./member-zone/tabs/member-tab-org-active.png": 964601,
	"./member-zone/tabs/member-tab-org-inactive.png": 131300,
	"./member-zone/tabs/member-tab-pro-active.png": 18136,
	"./member-zone/tabs/member-tab-pro-inactive.png": 345665,
	"./member-zone/tabs/tab-icon-org-purple-inactive.png": 425638,
	"./member-zone/tick.png": 425955,
	"./member-zone/value.svg": 159561,
	"./member-zone/video-cover.jpg": 172473,
	"./member-zone/vip-icon-1.png": 529823,
	"./member-zone/vip-icon-2-blue.png": 423855,
	"./member-zone/vip-icon-2.png": 575172,
	"./member-zone/vip-rich.png": 141996,
	"./member-zone/web-bg.png": 377394,
	"./member-zone/zone-icon-3x.png": 436060,
	"./member-zone/zone-icon-hover.png": 326659,
	"./member-zone/zone-icon.png": 53646,
	"./member-zone/zone-tip.png": 620370,
	"./member/arrow-icon.png": 602552,
	"./member/benefits-dialog-top-bg.png": 644538,
	"./member/benefits-table-3col.png": 810344,
	"./member/consult-advisor.svg": 661602,
	"./member/content-VIP.png": 343198,
	"./member/customer-bg.png": 756623,
	"./member/customer-item-bg.png": 285951,
	"./member/diamound.png": 28142,
	"./member/discount-tips-icon.png": 439613,
	"./member/hai.png": 511325,
	"./member/hide-VIP.png": 900577,
	"./member/icon.png": 534364,
	"./member/lock.svg": 27570,
	"./member/member-banner.png": 513914,
	"./member/normal-VIP.png": 365040,
	"./member/notice-trial.svg": 822244,
	"./member/open.png": 29463,
	"./member/penceil-bg.png": 6973,
	"./member/penceil-icon.png": 555039,
	"./member/pro.png": 856670,
	"./member/qrcode.png": 377345,
	"./member/rotate-VIP.png": 717820,
	"./member/table-org.png": 899786,
	"./member/table-pro.png": 331977,
	"./member/tryout-qr-day2to6.png": 911428,
	"./member/tryout-qr-end.png": 212060,
	"./member/version-icon-other-gray.png": 386354,
	"./member/version-icon-person-gray.png": 813083,
	"./member/version-logo-other.png": 490282,
	"./member/version-logo-person.png": 841885,
	"./member/years-member-text.png": 618584,
	"./menu-ai-logo.png": 137888,
	"./menuLogo.png": 228900,
	"./messageCenter.png": 581260,
	"./more-hover.png": 326654,
	"./more.png": 52419,
	"./more_dots.png": 143352,
	"./move-btn.png": 113240,
	"./moveBtn.png": 960135,
	"./moveBtnSp.png": 643286,
	"./net_work.png": 25771,
	"./network.svg": 545808,
	"./new-brm-logo.png": 402776,
	"./new-menu.png": 333786,
	"./newWealth.svg": 868271,
	"./news/all_subscription.svg": 431729,
	"./news/assistant-bg.png": 525142,
	"./news/assistant-qrcode-test.png": 956048,
	"./news/assistant-qrcode.png": 763329,
	"./news/close-bg.svg": 287466,
	"./news/empty_subscription.svg": 277263,
	"./news/oa-manager-bg.png": 79186,
	"./news/promotion-new-label.svg": 393165,
	"./no-auth.png": 709230,
	"./noLogo.png": 240868,
	"./normal-VIP.png": 71027,
	"./not-found.png": 579934,
	"./note_icon.png": 158370,
	"./notice_icon.png": 207734,
	"./null.png": 516287,
	"./number-one.png": 970492,
	"./number-three.png": 766364,
	"./number-two.png": 521534,
	"./openclaw/channel/DingTalk.png": 592247,
	"./openclaw/channel/Discord.png": 777212,
	"./openclaw/channel/Feishu.png": 681292,
	"./openclaw/channel/MQTT.png": 647676,
	"./openclaw/channel/Matrix.png": 538957,
	"./openclaw/channel/Mattermost.png": 292964,
	"./openclaw/channel/QQ.png": 381184,
	"./openclaw/channel/Telegram.png": 896707,
	"./openclaw/channel/WeChat.png": 449568,
	"./openclaw/channel/WeCom.png": 130759,
	"./openclaw/channel/iMessage.png": 421448,
	"./openclaw/channel/qr-popover-bg.png": 941371,
	"./openclaw/channel/twilio.png": 114918,
	"./openclaw/channel/xiaoyi.png": 338201,
	"./openclaw/channel/进门.png": 847519,
	"./openclaw/channel/默认.png": 8274,
	"./openclaw/claw-mascot.png": 415011,
	"./openclaw/claw-text-logo-en.png": 481227,
	"./openclaw/claw-text-logo.png": 274067,
	"./openclaw/cloud-pc-exchange-arrow.svg": 847741,
	"./openclaw/cloud-pc-exchange-evolution.svg": 540269,
	"./openclaw/cloud-pc-exchange-online.svg": 634795,
	"./openclaw/empty.png": 966923,
	"./openclaw/file-type/audio.png": 124136,
	"./openclaw/file-type/csv.png": 649750,
	"./openclaw/file-type/doc.png": 998860,
	"./openclaw/file-type/file.png": 526018,
	"./openclaw/file-type/html.png": 741611,
	"./openclaw/file-type/img.png": 692271,
	"./openclaw/file-type/markdown.png": 271351,
	"./openclaw/file-type/pdf.png": 924172,
	"./openclaw/file-type/ppt.png": 165970,
	"./openclaw/file-type/txt.png": 229902,
	"./openclaw/file-type/video.png": 529511,
	"./openclaw/file-type/xlsx.png": 449885,
	"./openclaw/job-disenable.svg": 927537,
	"./openclaw/job-enable.svg": 158813,
	"./openclaw/longxia.png": 432632,
	"./openclaw/mcp/all-mcp.png": 443179,
	"./openclaw/mcp/data-query.png": 982730,
	"./openclaw/mcp/file-management.png": 655963,
	"./openclaw/mcp/ir-data-management.svg": 647187,
	"./openclaw/mcp/meeting-management.png": 315964,
	"./openclaw/mcp/official-account-management.png": 384482,
	"./openclaw/mcp/professional-research-materials.png": 606369,
	"./openclaw/mcp/quantitative-backtest.png": 12282,
	"./openclaw/mcp/watchlist-management.png": 565602,
	"./openclaw/mcpClient.png": 161501,
	"./openclaw/prompt-chevron.svg": 425310,
	"./openclaw/prompt-icon.png": 560420,
	"./openclaw/skill-detail-bg.png": 992269,
	"./openclaw/skill/browser_visible.png": 371237,
	"./openclaw/skill/computer_use_tool_server.png": 418798,
	"./openclaw/skill/cron.png": 282080,
	"./openclaw/skill/dingtalk_channel.png": 228410,
	"./openclaw/skill/docx.png": 71110,
	"./openclaw/skill/file.png": 939722,
	"./openclaw/skill/file_reader.png": 247966,
	"./openclaw/skill/himalaya.png": 704132,
	"./openclaw/skill/manager-icon.png": 327501,
	"./openclaw/skill/market/broker-comment-daily.png": 301230,
	"./openclaw/skill/market/broker-comment-summary.png": 168209,
	"./openclaw/skill/market/broker-daily.png": 21186,
	"./openclaw/skill/market/chatgpt-image-helper.png": 642251,
	"./openclaw/skill/market/company-quick-search.png": 581149,
	"./openclaw/skill/market/conference-call-minutes.png": 129878,
	"./openclaw/skill/market/email-management.png": 579341,
	"./openclaw/skill/market/file-management.png": 82067,
	"./openclaw/skill/market/foreign-research-analysis.png": 433524,
	"./openclaw/skill/market/frontier-tech-panorama.png": 473961,
	"./openclaw/skill/market/gold-stock-analysis.png": 634403,
	"./openclaw/skill/market/hot-research.png": 721756,
	"./openclaw/skill/market/industry-event.png": 123912,
	"./openclaw/skill/market/investor-mindset-distill.png": 578576,
	"./openclaw/skill/market/jinbao-image-helper.png": 132673,
	"./openclaw/skill/market/macro-indicator-tracking.png": 576511,
	"./openclaw/skill/market/manager-background.png": 438323,
	"./openclaw/skill/market/marginal-change-tracking.png": 603697,
	"./openclaw/skill/market/new-logo/file-organize.png": 294826,
	"./openclaw/skill/market/new-logo/himalaya.png": 449936,
	"./openclaw/skill/market/new-logo/news.png": 638517,
	"./openclaw/skill/market/new-logo/watchlist-today-summary.png": 700276,
	"./openclaw/skill/market/news-query.png": 120463,
	"./openclaw/skill/market/ocr-recognition.png": 619339,
	"./openclaw/skill/market/ppt-presentation.png": 468736,
	"./openclaw/skill/market/quant-backtest.png": 693726,
	"./openclaw/skill/market/report-generation.png": 256572,
	"./openclaw/skill/market/research-activity-query.png": 725473,
	"./openclaw/skill/market/roadshow-semantic-search.png": 735118,
	"./openclaw/skill/market/smart-aggregated-search.png": 461485,
	"./openclaw/skill/market/ths.png": 104982,
	"./openclaw/skill/market/twitter-monitor.png": 802465,
	"./openclaw/skill/market/twitter-search.png": 536071,
	"./openclaw/skill/market/us-stock-dcf-model.png": 535392,
	"./openclaw/skill/market/us-stock-history.png": 796075,
	"./openclaw/skill/market/watchlist-summary.png": 236179,
	"./openclaw/skill/market/wechat-official-account.png": 786287,
	"./openclaw/skill/news.png": 200609,
	"./openclaw/skill/our-stock.png": 95989,
	"./openclaw/skill/pdf.png": 631556,
	"./openclaw/skill/pptx.png": 68696,
	"./openclaw/skill/skill-icon.png": 786655,
	"./openclaw/skill/us-stock.png": 62085,
	"./openclaw/skill/xlsx.png": 887061,
	"./openclaw/star.svg": 337470,
	"./openclaw/tools.png": 501,
	"./openclaw/welcome-logo.png": 539026,
	"./ordinary-vip.png": 491092,
	"./ordinary-vip.svg": 672926,
	"./org-logo.png": 492666,
	"./org-manage.png": 638170,
	"./other-vip.svg": 732550,
	"./other-vip2.png": 712658,
	"./other.png": 133164,
	"./output.png": 964935,
	"./pastSummaryBg.png": 251567,
	"./past_link.png": 97273,
	"./paste-import.png": 216321,
	"./pdf.png": 59348,
	"./pdf/page-down.svg": 421123,
	"./pdf/page-up.svg": 137724,
	"./pdf/presentation.svg": 608651,
	"./pdf/search.svg": 647179,
	"./pdf_translate.png": 567295,
	"./play-back.svg": 303372,
	"./playing.png": 54604,
	"./ppt.png": 495866,
	"./ppt_translate.png": 936053,
	"./profile.png": 608057,
	"./publicOpinion/wechat-guide-arrow.svg": 812697,
	"./publicOpinion/wechat-guide-asset.png": 261612,
	"./publicOpinion/wechat-guide-client.png": 788727,
	"./publicOpinion/wechat-guide-contact-bg.png": 274050,
	"./publicOpinion/wechat-guide-mcp.png": 550416,
	"./publicOpinion/wechat-guide-service.svg": 751591,
	"./publicOpinion/wechat-guide-wechat.svg": 118972,
	"./qr-bg.png": 407713,
	"./qr-code-login.png": 508979,
	"./qrcode-bg.png": 637808,
	"./qrcode-icon.png": 341522,
	"./questioAnswers-fast.png": 639304,
	"./questioAnswers.png": 941179,
	"./question.svg": 295302,
	"./question/heat-bg.png": 537483,
	"./question/heat-fire-active.svg": 450407,
	"./question/heat-fire.svg": 783132,
	"./question/question-stock-mode-item-bg.png": 281690,
	"./question/question-stock-mode-item-icon.svg": 305166,
	"./question/question-topic.svg": 565855,
	"./question/topic-icon.svg": 240088,
	"./questionnaire-top.png": 698367,
	"./ranking-bg.png": 945926,
	"./record-audio.png": 925577,
	"./record-img.png": 320813,
	"./record-vedio.png": 773953,
	"./record.png": 737679,
	"./record/record-bg.png": 522659,
	"./record/tencent.png": 50457,
	"./record/zoom.png": 500193,
	"./recordMeet-hover.png": 139743,
	"./recordMeet.png": 658842,
	"./recorder_avatar.png": 198492,
	"./refresh.png": 650623,
	"./register-card.png": 67888,
	"./report-fast.png": 506459,
	"./report-popup-top-bg.jpg": 706313,
	"./report-review-bg.jpg": 209297,
	"./report-tooltip-fold.png": 538850,
	"./report-tooltip.png": 648824,
	"./report.png": 968786,
	"./report_noauth.png": 64708,
	"./research-mode-right-bg.png": 581952,
	"./research-mode/html-editor/ai-change-history.svg": 104000,
	"./research-mode/html-editor/annotation-confirm.svg": 593996,
	"./research-mode/html-editor/chevron.svg": 376013,
	"./research-mode/html-editor/clear-annotations.svg": 526634,
	"./research-mode/html-editor/close.svg": 423400,
	"./research-mode/html-editor/command-key.svg": 953437,
	"./research-mode/html-editor/manual-tab-info.svg": 168861,
	"./research-mode/html-editor/resizer.svg": 272982,
	"./research-mode/html-editor/send-check.svg": 679253,
	"./research-mode/html-editor/upload.svg": 827119,
	"./research-tip.png": 512055,
	"./research/is-dep-ico.png": 410540,
	"./research/is-event-ico.png": 511323,
	"./research/is-first-ico.png": 51985,
	"./research/is-performance-ico.png": 610153,
	"./research/overseas-research-preview-bg.png": 76753,
	"./research/report-location.svg": 372946,
	"./research/translate-error.png": 633221,
	"./research/translate-running.png": 171770,
	"./research/translate-success.png": 4686,
	"./researchMode/related-ai-sessions-icon.svg": 736975,
	"./researchMode/share-download-docx.svg": 379996,
	"./researchMode/share-download-html.svg": 208045,
	"./researchMode/share-download-image.svg": 127317,
	"./researchMode/share-download-markdown.svg": 353413,
	"./researchMode/share-download-mobile.svg": 302036,
	"./researchMode/share-download-pdf.svg": 399440,
	"./researchMode/share-download-ppt.svg": 290030,
	"./researchMode/share-download-xlsx.svg": 482607,
	"./rewrite-hover.png": 205419,
	"./rewrite.png": 523974,
	"./rise.png": 589939,
	"./roadShow-fast.png": 690578,
	"./roadShow.png": 312993,
	"./roadshow-icon.png": 520671,
	"./s-default-bg.png": 394421,
	"./schedule-bg.png": 938503,
	"./schedule_add.svg": 944297,
	"./schedule_added.svg": 924966,
	"./search-empty.png": 516396,
	"./search_null.png": 412426,
	"./selected.png": 38815,
	"./self-selected/filter-range-icon.svg": 946623,
	"./self-selected/query-panel-collapse-btn-bg.svg": 462947,
	"./send.png": 764806,
	"./service-bg1.png": 929502,
	"./service-bg2.png": 249877,
	"./share-icon.png": 175345,
	"./signUpQrcode.png": 740210,
	"./srs-workbench/irm.png": 514867,
	"./srs-workbench/srs.png": 88951,
	"./statis/ai-note.png": 4100,
	"./statis/ai-note.svg": 796150,
	"./statis/chat-mode.png": 842029,
	"./statis/chat-mode.svg": 200923,
	"./statis/collapse-up.png": 317134,
	"./statis/collapse-up.svg": 468884,
	"./statis/jinbao.png": 715720,
	"./statis/jinbao.svg": 151568,
	"./statis/mcp.png": 178155,
	"./statis/mcp.svg": 668281,
	"./statis/nbi.png": 855294,
	"./statis/nbi.svg": 177256,
	"./statis/news.png": 219058,
	"./statis/news.svg": 36682,
	"./statis/note.png": 27283,
	"./statis/note.svg": 607375,
	"./statis/record.png": 585560,
	"./statis/record.svg": 392756,
	"./statis/report.png": 470745,
	"./statis/report.svg": 152593,
	"./statis/research-mode.png": 141286,
	"./statis/research-mode.svg": 899204,
	"./statis/review.png": 523,
	"./statis/review.svg": 587715,
	"./statis/roadshow.png": 109566,
	"./statis/roadshow.svg": 374610,
	"./statis/summary.png": 184047,
	"./statis/summary.svg": 757545,
	"./statis/task-mode.png": 866438,
	"./statis/task-mode.svg": 879364,
	"./statis/token.png": 910296,
	"./statis/token.svg": 425926,
	"./statistics/ai-usage-quota-bg.png": 935633,
	"./stock/fanzhuan.png": 916190,
	"./stock/hot-color.svg": 674938,
	"./stock/icon_1.png": 972310,
	"./stock/icon_2.png": 362989,
	"./stock/icon_3.png": 836836,
	"./stock/icon_4.png": 730427,
	"./stock/icon_5.png": 981426,
	"./stock/icon_6.png": 346569,
	"./stock/new_tag.png": 29058,
	"./stock/performance-bg.png": 819779,
	"./stock/performance-drawer-bg.jpg": 127189,
	"./stock/qingxu.jpg": 614263,
	"./strategic-meeting.png": 34176,
	"./summary-box-bg.png": 120616,
	"./summary-fast.png": 140811,
	"./summary.png": 513442,
	"./summary/overview-point-icon.png": 467385,
	"./summary/overview-qa-icon.png": 940541,
	"./summary_empty.png": 869692,
	"./survey.png": 871806,
	"./synced.png": 218114,
	"./syncing.png": 830681,
	"./systemConfig/buttonBg.png": 75171,
	"./systemConfig/coin.svg": 331257,
	"./systemConfig/frameFree.svg": 601027,
	"./systemConfig/framePro.svg": 878086,
	"./systemConfig/frameTeam.svg": 68230,
	"./systemConfig/free.png": 676276,
	"./systemConfig/has.png": 352804,
	"./systemConfig/more.gif": 454762,
	"./systemConfig/pro.png": 915313,
	"./systemConfig/proBg.png": 20312,
	"./systemConfig/team.png": 361393,
	"./systemConfig/teamBg.png": 540824,
	"./systemConfig/warn.svg": 121118,
	"./tecentMeetingQrcode.png": 450,
	"./tencent-meeting.png": 87325,
	"./text.svg": 16563,
	"./third-dialog-bg.png": 480386,
	"./trans-bg.png": 31150,
	"./translate-hover.png": 648333,
	"./translate.png": 490700,
	"./translate.svg": 956304,
	"./type-bg.png": 196554,
	"./un_select.png": 250926,
	"./unno.png": 937360,
	"./unselect.svg": 852675,
	"./upload/1.png": 327259,
	"./upload/2.png": 429696,
	"./upload/3.png": 553897,
	"./upload/4.png": 903926,
	"./upload/view-left.png": 335549,
	"./upload/view-left.svg": 962023,
	"./upload/view-left_hover.png": 393918,
	"./upload/view-right.png": 402270,
	"./upload/view-right.svg": 736706,
	"./upload/view-right_hover.png": 270421,
	"./uploading.png": 431887,
	"./vector.png": 795397,
	"./version-bg.png": 707392,
	"./version/circle.png": 633487,
	"./video.png": 112623,
	"./vip-tryout-blink.png": 95102,
	"./wait-icon.png": 710041,
	"./waitPlay.png": 358509,
	"./warn.svg": 854878,
	"./wechat-square.png": 801132,
	"./wechatPlatform/original-info-bg.png": 267698,
	"./xls.png": 245081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 821382;